import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createPOCustomField.createPOCustomFieldForm`

export default defineMessages({
  labelCaptionLabel: {
    id: `${scope}.labelCaptionLabel`,
    defaultMessage: 'Label caption',
  },
  labelCaptionPlaceholder: {
    id: `${scope}.labelCaptionPlaceholder`,
    defaultMessage: 'Label caption',
  },
  labelCaptionRequiredError: {
    id: `${scope}.labelCaptionRequiredError`,
    defaultMessage: 'Label caption is required',
  },
  labelCaptionMaxLengthError: {
    id: `${scope}.labelCaptionMaxLengthError`,
    defaultMessage: 'Label caption must be at most 200 characters',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
})
